module.exports = __webpack_public_path__ + "static/media/logo.06825633.png";